import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {PaymentusRoutingModule} from './paymentus-routing.module';
import {PipeModule} from '../../shared/pipe/pipe.module';
import {
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatDialogModule,
  MatExpansionModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatTableModule,
  MatToolbarModule, MatTooltipModule
} from '@angular/material';
import {TextMaskModule} from 'angular2-text-mask';
import {AuthModule} from '../../auth/auth.module';
import {CustomerEnrollModule} from '../../customer-enroll/customer-enroll.module';
import {PaymentusService} from './paymentus.service';
import {AddPaymentMethodComponent} from './add-payment-method.component';
import {SafePipe} from './SafePipe';
import {SafeStylePipe, SubmitPaymentComponent} from './make-payment/submit-payment.component';
import {ViewPaymentMethodsComponent} from './view-payment-methods/view-payment-methods.component';
import { PaymentReceiptComponent } from './make-payment/receipt/payment-receipt/payment-receipt.component';

@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    CommonModule,
    PaymentusRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule.forRoot(),
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatTableModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    TextMaskModule,
    AuthModule,
    MatExpansionModule,
    MatRadioModule,
    MatTooltipModule,
  ],
  providers: [PaymentusService],
  bootstrap: [],
  exports: [
    AddPaymentMethodComponent,
    SubmitPaymentComponent,
    PaymentReceiptComponent,
    ViewPaymentMethodsComponent
  ],
  declarations: [
    SafePipe, SafeStylePipe, AddPaymentMethodComponent, SubmitPaymentComponent, ViewPaymentMethodsComponent, PaymentReceiptComponent
  ]
})
export class PaymentusModule { }



// WEBPACK FOOTER //
// ./src/app/payment/paymentus/paymentus.module.ts